module.exports = __webpack_public_path__ + "img/banner-estxfsr-free.66a58f3e.png";